export default __webpack_public_path__ + "static/media/hero-bcg.a876f19f.jpeg";